(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('filterRange', {
            templateUrl: 'app/components/filter-range/filter-range.html',
            controller: filterRangeController,
            bindings: {
                name: '@',
                inputType: '@?',
                placeholder: '@',
                modelMin: '=',
                modelMax: '=',
                leftPosition: '=',
                fullscreen: '=',
                actionOnClose: '&',
                type: '@',
                unit: '@?'
            }
        });

    /** @ngInject */
    function filterRangeController($translate, $element, toastr, $timeout, systemConstants, $window, $localStorage) {
        var $ctrl = this;

        var inputTypes = ['button', 'field'];
        var defaultInputType = 'button';

        $ctrl.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MIN_SM;

        $element.on('hidden.bs.dropdown', function () {
            if (!$ctrl.modelMin && !$ctrl.modelMax) {
                return
            } else if (!$ctrl.modelMin) {
                toastr.error($translate.instant('flyers.filters.error.empty-min-value'));
                $ctrl.modelMax = null;
            } else if (!$ctrl.modelMax) {
                toastr.error($translate.instant('flyers.filters.error.empty-max-value'));
                $ctrl.modelMin = null;
            } else if ($ctrl.modelMin > $ctrl.modelMax) {
                toastr.error($translate.instant('flyers.filters.error.invalid-range'));
                $ctrl.modelMin = null;
                $ctrl.modelMax = null;
            } else if($ctrl.actionOnClose) {
                $ctrl.actionOnClose();
            }
        });

        $ctrl.isSelected = function () {
            return $ctrl.modelMin && $ctrl.modelMax;
        };

        $ctrl.getPlaceholderText = function () {
            return $translate.instant($ctrl.placeholder) + ($ctrl.isSelected() ? ' | ' : '');
        };

        $ctrl.getSelectedText = function () {
            var selectedText = "";
            var centsSeparator = $ctrl.currency ?  $ctrl.currency.centsSeparator :",";
            var thousandsSeparator = $ctrl.currency ?  $ctrl.currency.thousandsSeparator :".";
            if ($ctrl.type === 'price' && $ctrl.currency) {
                var minPrice = formatMoney($ctrl.modelMin, $ctrl.currency.prefix, 2, centsSeparator, thousandsSeparator);
                var maxPrice = formatMoney($ctrl.modelMax, $ctrl.currency.prefix, 2, centsSeparator, thousandsSeparator);
                maxPrice = maxPrice.replace($ctrl.currency.prefix, '');
                selectedText = minPrice + ' - ' + maxPrice;
            } else if ($ctrl.type === 'area' && $ctrl.unit) {
                var minArea = formatMoney($ctrl.modelMin, '', 2, centsSeparator, thousandsSeparator).trim();
                var maxArea = formatMoney($ctrl.modelMax, '', 2, centsSeparator, thousandsSeparator).trim();
                selectedText = minArea + ' - ' + maxArea + ' ' + $ctrl.unit;
            } else {
                selectedText = $ctrl.modelMin + ' - ' + $ctrl.modelMax;
            }
            return selectedText;
        }

        $ctrl.clearSelection = function ($event) {
            if($event) {
                $event.stopPropagation();
            }
            $ctrl.modelMin = null;
            $ctrl.modelMax = null;

            if (typeof $ctrl.actionOnClose === 'function') {
                $timeout(function () {
                    $ctrl.actionOnClose();
                }, 0);
            }
        };

        $ctrl.$onInit = function () {
            $ctrl.type = $ctrl.type ? $ctrl.type : 'number';

            loadCurrencyConfiguration();

            if (!$ctrl.inputType) {
                $ctrl.inputType = defaultInputType;
            } else if (!inputTypes.includes($ctrl.inputType)) {
                $ctrl.inputType = defaultInputType;
            }
        };

        function loadCurrencyConfiguration() {
            $ctrl.currency = $localStorage.defaultStore.storeInfo.currencyConfiguration;
        }
    }
})();
